export const MAX_QUESTION_IMAGE_SIZE_KB = 3072 // 3 MB
export const MAX_QUESTION_IMAGE_SIZE_BYTES = MAX_QUESTION_IMAGE_SIZE_KB * 1024
export const MAX_QUESTION_IMAGE_DIMENSION = 1600
